var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.131 34.08a.984.984 0 0 0 1.409 0L34.2 21.255c5.28-5.348 1.528-14.588-5.98-14.588-4.51 0-6.578 3.314-7.384 3.932-.81-.62-2.866-3.932-7.384-3.932-7.485 0-11.282 9.216-5.98 14.588z"
  })));
};
export default SvgLike;